import { USERS_WITHOUT_CREDENTIALS_ONLY } from '$lib/services/auth/policies';
import { REG_PATH_PRESERVE_QUERY_EXCEPTION_HANDLER } from '$lib/services/auth/policy-exception-handler';

export const policy = USERS_WITHOUT_CREDENTIALS_ONLY;

export const policyExceptionHandler = REG_PATH_PRESERVE_QUERY_EXCEPTION_HANDLER;
